import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useVendorsStore} from "../../store/vendors.store";

export const useVendorWarehouseSales = () => {
    const setWarehouseSales = useVendorsStore((state) => state.setWarehouseSales);

    return useMutation(PartnerApi.vendorWarehouseSales, {
        onSuccess: (data) => {
            setWarehouseSales(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};